import { render, staticRenderFns } from "./SupportInformation.vue?vue&type=template&id=76f4dcc4&"
import script from "./SupportInformation.vue?vue&type=script&lang=js&"
export * from "./SupportInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports